import { useEffect } from "react";

/**
 * Small SEO helper — sets document.title, meta description and canonical
 * for the current page. All three restore on unmount.
 */
export default function useSEO({ title, description, canonicalPath }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    // description
    let descTag = document.querySelector('meta[name="description"]');
    const createdDesc = !descTag;
    if (createdDesc) {
      descTag = document.createElement("meta");
      descTag.name = "description";
      document.head.appendChild(descTag);
    }
    const prevDesc = descTag.getAttribute("content");
    if (description) descTag.setAttribute("content", description);

    // canonical
    let canonTag = document.querySelector('link[rel="canonical"]');
    const createdCanon = !canonTag;
    if (createdCanon) {
      canonTag = document.createElement("link");
      canonTag.rel = "canonical";
      document.head.appendChild(canonTag);
    }
    const prevCanon = canonTag.getAttribute("href");
    if (canonicalPath) {
      const origin = typeof window !== "undefined" ? window.location.origin : "";
      canonTag.setAttribute("href", origin + canonicalPath);
    }

    return () => {
      document.title = prevTitle;
      if (createdDesc && descTag.parentNode) descTag.parentNode.removeChild(descTag);
      else if (descTag && prevDesc !== null) descTag.setAttribute("content", prevDesc);
      if (createdCanon && canonTag.parentNode) canonTag.parentNode.removeChild(canonTag);
      else if (canonTag && prevCanon !== null) canonTag.setAttribute("href", prevCanon);
    };
  }, [title, description, canonicalPath]);
}
